import { Injectable } from "@angular/core";
import { MC_APPLICATIONS_ERROR, MCEnvironmentsService, MCStore } from "@maslul/common-services";
import { Observable } from "rxjs";

export class GeneralStoreData {
    formState: any;
    errorPageCode!: MC_APPLICATIONS_ERROR;
}
const GENERAL: GeneralStoreData =
{
    formState: {},
    errorPageCode: MC_APPLICATIONS_ERROR.general
}

@Injectable({
    providedIn: 'root',
})
export class GeneralStore extends MCStore<GeneralStoreData> {

    constructor(protected override environmentsService: MCEnvironmentsService) {
        super('', GENERAL, environmentsService);
    }


    getFormState(): Observable<any> {
        return this.select(s => s.formState);
    }

    setFormState(formState: any) {
        this.updateState('[General MCStore Service] set formState', { formState })
    }

    getErrorPageCode(): Observable<MC_APPLICATIONS_ERROR> {
        return this.select(s => s.errorPageCode);
    }

    setErrorPageCode(errorPageCode: MC_APPLICATIONS_ERROR) {
        this.updateState('[General MCStore Service] set errorPageCode', { errorPageCode })
    }
}